<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <div>
          <div>
            <h6 class="heading-small text-muted mb-4">Template</h6>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="selectedAccountReportTemplateId"
                  style="width: 100%"
                  placeholder="Select Template"
                  :filter-option="filterOption"
                  @change="
                    (event) => {
                      setAccountReportTemplate(event);
                      setOrigConfig(event);
                    }
                  "
                >
                  <a-select-option
                    v-for="template in options.accountReportTemplates"
                    :value="template.id"
                    :key="template.id"
                    :label="template.name"
                  >
                    {{ template.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </div>
        <br />
        <form role="form" @submit.prevent>
          <h6 class="heading-small text-muted mb-4">Filters</h6>
          <div>
            <div>
              <label>Report Type Display</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.report_type"
                  style="width: 100%"
                  placeholder="Select Report Type"
                  :filter-option="filterOption"
                  @change="onChangeReportType"
                >
                  <a-select-option
                    v-for="reportType in options.reportTypes"
                    :value="reportType.id"
                    :key="reportType.id"
                    :label="reportType.name"
                  >
                    {{ reportType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div><label for="">Game Code</label></div>
            <div>
              <base-input>
                <a-select
                  placeholder="Select Game Code"
                  v-model="table.appendedParams.game_id"
                  showSearch
                  mode="multiple"
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="(game, i) in options.games"
                    :key="i"
                    :value="game.id"
                    >{{ game.game_code }}</a-select-option
                  >
                </a-select>
              </base-input>
            </div>
          </div>
          <div v-if="table.appendedParams.report_type == 'list'">
            <div>
              <label for="">Member ID</label>
            </div>
            <div>
              <base-input>
                <a-input
                  placeholder="Member ID"
                  v-model="table.appendedParams.member_id"
                />
              </base-input>
            </div>
          </div>
          <div>
            <div>
              <label for="">Outcome</label>
            </div>
            <div>
              <base-input>
                <a-select
                  placeholder="Select Outcome"
                  v-model="table.appendedParams.result"
                  showSearch
                  mode="multiple"
                >
                  <a-select-option
                    v-for="(reward, i) in options.rewards"
                    :key="i"
                    :value="reward"
                    >{{ reward }}</a-select-option
                  >
                </a-select>
              </base-input>
            </div>
          </div>
          <div v-if="table.appendedParams.report_type == 'list'">
            <div>
              <label>Date (From - To)</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-range-picker
                    v-model="table.appendedParams.created_at"
                    :default-value="[
                      table.appendedParams.created_at_from,
                      table.appendedParams.created_at_to
                    ]"
                    :format="dateFormat"
                    @change="dateRangeOnChange"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="setFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.appendedParams"
          :sortOrder="table.sortOrder"
          :sortParams="getSortParam"
          :multiSort="table.multiSort"
          :multiSortKey="table.multiSortKey"
          :displayfooterNotes="table.displayfooterNotes"
          @doneLoading="generateAmountTotal"
        >
          <template #headerButtons>
            <div>
              <b-button
                v-if="selectedActions.includes('Customize')"
                variant="primary"
                @click.prevent="openDrawer('report_template')"
                >Customize</b-button
              >
              <b-button
                v-if="
                  selectedActions.includes('Download') ||
                  selectedActions.includes('Send')
                "
                variant="danger"
                @click.prevent="openDrawer('export_data')"
                >Export</b-button
              >
            </div>
          </template>
          <template #footerNotes>
            <h6 class="heading-small text-muted mb-4">
              {{ table.footerNote }}
            </h6>
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <AccountReportTemplate
                v-if="drawer.action == 'report_template'"
                :accountReport="accountReport"
                :accountReportTemplate="accountReportTemplate"
                :selectedAccountReportTemplateColumns="tableFields"
                :selectedAccountReportTemplateFilters="table.appendedParams"
                :selectedAccountReportTemplateSorts="table.sortOrder"
                :updatedFilter="updatedFilters"
                @setTableColumns="setTableColumns"
                @setAccountReportTemplate="getAccountReportData"
                @deleteAccountReportTemplate="getAccountReportData"
                @closeDrawer="closeDrawer"
                @setUpdatedFilter="updatedFilters = false"
              />

              <ExportDataForm
                v-if="drawer.action == 'export_data'"
                :template="selectedAccountReportTemplateId"
                :jsonFields="toJsonFields"
                :filename="filename"
                :apiUrl="tableApiUrl"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
import PageHeader from '../../../components/Page/Header.vue';
import PageContent from '../../../components/Page/Content.vue';
import PageTable from '../../../components/Page/Table.vue';
import AccountReportTemplate from '../Drawers/AccountReportTemplateForm.vue';
import ExportDataForm from '../Drawers/ExportDataForm.vue';
import secureStorage from '../../../controllers/secureStorage';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
const TIMEZONE = process.env.TIMEZONE;

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    AccountReportTemplate,
    ExportDataForm
  },
  data() {
    return {
      filename: `Report - ${moment().format('YYYY-MM-DDTHHmmss.SSS')}.csv`,
      updatedFilters: false,
      originalFilter: null,
      gradientType: 'gradient-yellow',
      accountReport: null,
      dateFormat: 'YYYY-MM-DD',
      accountReportTemplate: null,
      selectedAccountReportTemplateId: null,
      saveFilters: false,
      saveSorts: false,
      drawer: {
        visible: false,
        width: 600,
        placement: 'right',
        action: null
      },
      table: {
        title: 'Scratch Card Reports',
        apiUrl:
          '/api/v1/reports/scratch_card?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [],
        appendedParams: {
          game_id: [],
          result: [],
          member_id: null,
          first_name: null,
          last_name: null,
          created_at: [
            moment(new Date()).format('YYYY-MM-DD'),
            moment(new Date()).format('YYYY-MM-DD')
          ],
          created_at_from: moment(new Date()).format('YYYY-MM-DD'),
          created_at_to: moment(new Date()).format('YYYY-MM-DD'),
          report_type: 'consolidated',
          export_data: false,
          filter: false
        },
        multiSort: true,
        multiSortKey: 'alt',
        sortOrder: null,
        footerNote: '',
        displayfooterNotes: true
      },
      options: {
        reportTypes: [
          { id: 'list', name: 'Listing' },
          { id: 'consolidated', name: 'Consolidated' }
        ],
        reportTemplates: [],
        accountReportTemplates: null,
        games: [],
        rewards: []
      }
    };
  },
  methods: {
    generateAmountTotal(data) {
      let valueKey = 'count',
        total;
      const rows = data.data;
      if (rows != undefined) {
        total = rows.reduce((acc, row) => acc + row[valueKey], 0);
      }
      if (isNaN(total)) {
        this.table.footerNote = `Total: 0`;
      } else {
        this.table.footerNote = `Total: ${total}`;
      }
    },
    filterOption(inputValue, option) {
      return (
        option?.componentOptions?.propsData?.label
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) !== -1
      );
    },
    async getTransactionTypes() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_transaction_types',
        {
          per_page: 1000
        }
      );
      this.options.transactionTypes = response.data;
    },

    async getSites() {
      // const defaultSite = secureStorage.getItem('defaultSite');
      if (this.inHeadOffice) {
        this.options.sites = secureStorage.getItem('visitingSites');
      } else {
        this.options.sites = [secureStorage.getItem('currentSite')];
      }
      // this.table.appendedParams.site_ids.push(defaultSite.id);
    },

    async getAccountReportData() {
      let accountReport = [];
      const reportType = this.table.appendedParams.report_type;
      switch (reportType.toLowerCase()) {
        case 'consolidated':
          accountReport = await HTTPRequest.getRequest(
            '/api/v1/account_reports/SCRATCH_CARD_REPORTS_AGGREGATE/default'
          );
          break;

        case 'list':
          accountReport = await HTTPRequest.getRequest(
            '/api/v1/account_reports/SCRATCH_CARD_REPORTS_LIST/default'
          );
          break;
      }
      this.accountReport = accountReport;
      await this.setAccountReportTemplate(
        accountReport.accountReportTemplates[0]
      );
      this.setOrigConfig(accountReport.accountReportTemplates[0]);
      await this.getAccountReportTemplates();
    },
    async getAccountReportTemplates() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/account_report_templates/' +
          this.accountReport.code +
          '/templates'
      );
      this.options.accountReportTemplates = data;
    },

    setAccountReportTemplate(accountReportTemplate) {
      let accountReportTemplateData;
      if (typeof accountReportTemplate == 'number') {
        this.selectedAccountReportTemplateId = accountReportTemplate;
        for (const template of this.options.accountReportTemplates) {
          if (accountReportTemplate == template.id) {
            this.accountReportTemplate = template;
            accountReportTemplateData = JSON.parse(template.config);
          }
        }
      } else {
        this.accountReportTemplate = accountReportTemplate;
        accountReportTemplateData = JSON.parse(accountReportTemplate.config);
        this.selectedAccountReportTemplateId = accountReportTemplate.id;
      }

      /** Clear the previous' template's filter/s */
      this.clearTableFilters();

      /** Clear the previous' template's sort/s */
      this.clearTableSorts();

      /** Load template's default columns */
      this.setTableColumns(accountReportTemplateData.columns);

      if (
        accountReportTemplateData.filters &&
        Object.keys(accountReportTemplateData.filters).includes('nonbxi')
      ) {
        const spreadFilter = { ...accountReportTemplateData.filters };
        delete spreadFilter['nonbxi'];
        accountReportTemplateData.filters = spreadFilter;
      }
      /** Load template's default filters */
      this.setTableFilters(accountReportTemplateData.filters);

      /** Load template's default sort */
      this.setTableSorts(accountReportTemplateData.sorts);
    },

    setTableColumns(columns = []) {
      /**
       * Note: Amongst the other 2 methods on clearing the table fields,
       * this one worked as this doesn't alter the original array instance
       *
       * this.table.fields = this.table.fields.splice(0, this.table.fields.length);
       * this.table.fields = [];
       * */
      /** Clear table fields */
      this.table.fields.length = 0;

      const tableFields = this.table.fields;
      if (columns != null) {
        columns.forEach((column) => {
          /** Check if current "column" is already in the table */ ``;
          let hasField = tableFields.find(
            (field) => field.name === column.name
          );
          if (typeof hasField === 'undefined') {
            if (Object.keys(column).includes('value')) {
              if (column.value) {
                /** Push to table */
                // console.log('Pushing column: ', column.name);
                if (column.name == 'claim_date') {
                  column.formatter = function (date) {
                    if (moment(date).isValid()) {
                      return moment(date, TIMEZONE).format('YYYY-MM-DD h:mm A');
                    }
                    return null;
                  };
                }
                this.table.fields.push(column);
              }
            } else {
              /** Push to table */
              // console.log('Pushing column: ', column.name);
              if (column.name == 'claim_date') {
                column.formatter = function (date) {
                  if (moment(date).isValid()) {
                    return moment(date, TIMEZONE).format('YYYY-MM-DD h:mm A');
                  }
                  return null;
                };
              }
              this.table.fields.push(column);
            }
          }
        });
      }
    },

    setTableFilters(filters = {}) {
      if (Object.keys(filters).length !== 0) {
        this.table.appendedParams = filters;
        // setTimeout(() => this.setFilter(), 200);
      }
    },

    setTableSorts(sorts = []) {
      if (sorts && sorts.length > 0) {
        this.table.sortOrder = sorts;
        // setTimeout(() => this.setFilter(), 200);
      } else {
        this.table.sortOrder = sorts;
      }
    },

    getSortParam(sortOrder) {
      return sortOrder
        .map(function (sort) {
          return sort.field + '|' + sort.direction;
        })
        .join(',');
    },

    async onChangeReportType() {
      /** Get report data for the report type */
      await this.getAccountReportData();
      /** Clear filters for the table */
      await this.clearTableFilters();

      /** Reload table */
      // await this.setFilter();

      /** clear table data */
      this.$root.$emit('clearTableData');
    },

    clearTableFilters() {
      this.table.appendedParams.game_id = [];
      this.table.appendedParams.result = [];
      this.table.appendedParams.member_id = null;
      this.table.appendedParams.created_at = [
        moment(new Date()).format('YYYY-MM-DD'),
        moment(new Date()).format('YYYY-MM-DD')
      ];
    },

    clearTableSorts() {
      this.table.sortOrder = null;
    },

    openDrawer(action) {
      this.drawer.visible = true;
      this.drawer.action = action;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.drawer.action = null;
    },

    setFilter() {
      this.table.appendedParams.filter = true;
      this.originalFilter === JSON.stringify(this.table.appendedParams)
        ? (this.updatedFilters = false)
        : (this.updatedFilters = true);
      this.$root.$emit('refreshTable');
    },

    dateRangeOnChange(dateObj, dateString) {
      this.table.appendedParams.created_at_from = dateString[0];
      this.table.appendedParams.created_at_to = dateString[1];
      this.table.appendedParams.created_at = [dateString[0], dateString[1]];
      // console.log('dateObj: ', dateObj);
      // this.setFilter();
    },
    serializeQuery(params, prefix) {
      const query = Object.keys(params).map((key) => {
        if (params[key]) {
          const value = params[key];

          if (params.constructor === Array) {
            key = `${prefix}[]`;
          } else if (params.constructor === Object) {
            key = prefix ? `${prefix}[${key}]` : key;
          }

          if (typeof value === 'object') {
            return this.serializeQuery(value, key);
          } else {
            return `${key}=${encodeURIComponent(value)}`;
          }
        }
      });
      let serializedQuery = null;
      serializedQuery = query.filter((elem) => elem != '');
      serializedQuery = serializedQuery.filter((elem) => elem != undefined);
      return [].concat.apply([], serializedQuery).join('&');
    },
    setOrigConfig(event) {
      if (typeof event == 'number') {
        for (const template of this.options.accountReportTemplates) {
          if (event == template.id) {
            const jConfig = JSON.parse(template.config);
            if (Object.keys(jConfig).includes('filter')) {
              this.originalFilter = JSON.stringify(
                JSON.parse(jConfig.config).filters
              );
            } else {
              this.originalFilter = JSON.stringify(this.table.appendedParams);
            }
          }
        }
      } else {
        const jConfig = JSON.parse(event.config);
        if (Object.keys(jConfig).includes('filter')) {
          this.originalFilter = JSON.stringify(jConfig.filters);
        } else {
          this.originalFilter = JSON.stringify(this.table.appendedParams);
        }
      }
    },
    async fetchOptions() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/reports/scratch_card/options'
      );
      this.options.games = data.games;
      this.options.rewards = data.rewards;
    }
  },
  created() {
    this.getSites();
    this.getAccountReportData();
    // fetch all games to get names
    // fetch all outcomes(rewards)
    this.fetchOptions();

    this.$store.dispatch('setCurrentModule', 'ScratchCardReport');
  },
  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  },

  watch: {
    inHeadOffice: function () {
      if (this.inHeadOffice) {
        this.options.sites = secureStorage.getItem('visitingSites')
          ? secureStorage.getItem('visitingSites')
          : [];
      } else {
        this.options.sites = [secureStorage.getItem('currentSite')];
      }
    },
    'table.appendedParams.report_type': function (value, oldValue) {
      if (oldValue != value) {
        if (value == 'consolidated') {
          this.table.displayfooterNotes = true;
          this.table.appendedParams.created_at_from = '';
          this.table.appendedParams.created_at_to = '';
          this.table.appendedParams.created_at = [];
        } else {
          this.table.appendedParams.created_at_from = moment(new Date()).format(
            'YYYY-MM-DD'
          );
          this.table.appendedParams.created_at_to = moment(new Date()).format(
            'YYYY-MM-DD'
          );
          this.table.appendedParams.created_at = [
            moment(new Date()).format('YYYY-MM-DD'),
            moment(new Date()).format('YYYY-MM-DD')
          ];
          this.table.footerNote = '';
          this.table.displayfooterNotes = false;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions',
      headOfficeId: 'getHeadOffice'
    }),
    inHeadOffice() {
      return secureStorage.getItem('currentSiteId') == this.headOfficeId
        ? true
        : false;
    },
    tableFields() {
      const _tableFields = [...this.table.fields];
      return _tableFields;
    },

    tableApiUrl() {
      const tableApiUrl = this.table.apiUrl;
      const _tableParams = { ...this.table.appendedParams };
      _tableParams.export_data = true; // Update to true, for exportable data
      const _tableSort = [...this.table.sortOrder];
      let sorts, filters;

      /** Create query string for "sort" first if there are sorting */
      if (_tableSort.length > 0) {
        let i = 0;
        for (let sort of _tableSort) {
          if (i == 0) {
            sorts = 'sort=' + sort.field + '|' + sort.direction;
          } else {
            sorts += ',' + sort.field + '|' + sort.direction;
          }
          i++;
        }
      }

      /** Parse object for query string */
      filters = this.serializeQuery(_tableParams);
      if (tableApiUrl.includes('?')) {
        return tableApiUrl + '&' + sorts + '&' + filters;
      } else {
        return tableApiUrl + '?' + sorts + '&' + filters;
      }
    },
    toJsonFields: function () {
      const _tableFields = [...this.table.fields];
      let jsonFields = {};

      for (let field of _tableFields) {
        jsonFields[field.title] = field.name;
        switch (field.name) {
          case 'claim_date':
            jsonFields[field.title] = {
              field: field.name,
              callback: (date) => {
                if (moment(date).isValid()) {
                  return moment(date).format('YYYY-MM-DD h:mm A');
                }
                return null;
              }
            };
            break;
        }
      }

      return jsonFields;
    }
  }
};
</script>

<style scoped></style>
